import { TFunction } from 'i18next';

import { CampaignCountry } from '@features/campaigns/shared/types/campaign';
import { I18nNameSpaces } from '@shared/consts/i18n';
import { objectKeys } from '@shared/utils/objectKeys';

export const getCampaignCountryOptions = (t: TFunction<I18nNameSpaces['CAMPAIGNS']>) => {
  return objectKeys(CampaignCountry).map((country) => ({
    label: t(`page.list.campaignCountry.${country.toLowerCase()}`),
    value: CampaignCountry[country],
  }));
};
